<template>
  <div class="mod-id-info">
    <div class="mod-auth-info mod-group">
      <div class="cell-header">
        <h3>身份认证信息</h3>
      </div>
      <div class="cell-body clearfix">
        <div class="cell-auth-header clearfix">
          <span>身份类别</span>
          <span>认证状态</span>
        </div>
        <div class="cell-auth-item clearfix" v-for="name in idList" :key="name">
          <span>{{ name }}</span>
          <span class="has-auth"><user-icon type="icon-roundcheckfill" /> 已认证</span>
        </div>
      </div>
    </div>
    <a-button type="primary" class="apply-auth-btn" @click="onNext">添加申请</a-button>
    <div class="mod-apply-info mod-group">
      <div class="cell-header">
        <h3>申请记录</h3>
      </div>
      <div class="cell-body clearfix">
        <div class="cell-apply-header clearfix">
          <span>身份类别</span>
          <span>工作单位/学校</span>
          <span>证件号码</span>
          <span>申请进度</span>
        </div>
        <div class="cell-apply-item clearfix" v-for="item in authList" :key="(item.organization + item.type)">
          <span>{{ item.type | typeFilter(idTypes) }}</span>
          <span>{{ item.organization }}</span>
          <span>{{ item.idCard }}</span>
          <span class="verify" v-if="(item.auditStatus === 0)"><a-icon type="clock-circle" :style="{ fontSize: '12px' }" /> 审核中</span>
          <span class="pass" v-else-if="(item.auditStatus === 1)"><user-icon type="icon-roundcheckfill" /> 审核通过</span>
          <span class="refuse" v-else><a-icon type="close-circle" :style="{ fontSize: '12px' }" /> 已拒绝</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchProfessionalInfo, fetchAuthList } from '@/api/member'

export default {
  props: {
    userInfo: {
      type: Object,
      default () {
        return {}
      }
    },
    type: String,
    idTypes: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      idList: [],
      authList: []
    }
  },
  async created () {
    try {
      const data = await fetchProfessionalInfo({ category: 'occupation' })
      if (data && data.tags && data.tags.length) {
        this.idList = data.tags.map(tag => {
          return tag.name
        })
      }
    } catch (error) {
      this.$message.error(error.message)
    }

    try {
      const authList = await fetchAuthList({
        pageSize: 100,
        currentPage: 1
      })
      const list = (authList && authList.list) || []
      this.authList = list.map(item => {
        const { type, authInfo, idCard, auditStatus } = item
        const { organization } = authInfo || {}
        return {
          type,
          organization,
          idCard,
          auditStatus
        }
      })
    } catch (error) {
      console.log(error)
    }
  },
  methods: {
    onNext () {
      this.$emit('next')
    }
  },
  filters: {
    typeFilter (type, idTypes) {
      if (type === -1) {
        return '实名认证'
      }
      const currentType = (idTypes || []).find(id => type === id.value)
      return (currentType && currentType.label) || ''
    }
  }
}
</script>
